import { useCallback, useEffect, useState } from 'react';
import { apiRequest } from '../utils/apiUtils';

export interface ThreadMessage {
  id: string;
  body: string;
  authorId: string;
  createdAt: string;
  author?: { id: string; name: string; avatar?: string | null };
}

export function useJoinApplicationThread(
  matchId: string | null,
  applicationId: string | null,
  open: boolean
) {
  const [messages, setMessages] = useState<ThreadMessage[]>([]);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!matchId || !applicationId) return;
    setLoading(true);
    setError(null);
    const res = await apiRequest<ThreadMessage[]>(
      `/matches/${matchId}/join-applications/${applicationId}/messages`
    );
    if (res.error) {
      setError(res.error);
      setMessages([]);
    } else {
      setMessages(Array.isArray(res.data) ? res.data : []);
    }
    setLoading(false);
  }, [matchId, applicationId]);

  useEffect(() => {
    if (open) {
      void load();
    } else {
      setMessages([]);
    }
  }, [open, load]);

  const send = useCallback(
    async (body: string) => {
      if (!matchId || !applicationId) return { error: 'No data' };
      const text = body.trim();
      if (!text) return { error: 'Mensaje vacío' };
      setSending(true);
      const res = await apiRequest(
        `/matches/${matchId}/join-applications/${applicationId}/messages`,
        { method: 'POST', body: { body: text } }
      );
      setSending(false);
      if (!res.error) {
        await load();
      }
      return res;
    },
    [matchId, applicationId, load]
  );

  return { messages, loading, sending, error, send, refresh: load };
}
